<!-- <h3>Souhaitez-vous diffuser...</h3> -->

<div>
    <!-- <mat-slide-toggle   (change)="changeWeekDay($event)" labelPosition="after">Certains jours en particulier ?</mat-slide-toggle> -->
    <wncm-form-control-slide-toggle
        *ngIf="indexSelected != 0 && userService.hasFeature('DailySensitivity')"
        [control]="isDayFiltered"
        placeholder="Certains jours en particulier"
    ></wncm-form-control-slide-toggle>

    <!-- Jours de la semaine -->
    <div class="paramLine" *ngIf="stateWeekDays && indexSelected != 0">
        <wncm-form-control-select
            [readOnly]="ReadOnly"
            [multiple]="true"
            [control]="weekDaysControl"
            [from]="diffusionDay$"
            label="name"
            placeholder="Jours de la semaine"
        ></wncm-form-control-select>
    </div>
    <hr
        *ngIf="indexSelected != 0 && userService.hasFeature('DailySensitivity')"
    />

    <!-- Heures spécifiques -->
    <wncm-form-control-slide-toggle
        *ngIf="userService.hasFeature('HourlySensitivity')"
        [control]="isHourFiltered"
        placeholder="À des heures précises"
    ></wncm-form-control-slide-toggle>
    <div class="paramLine" *ngIf="stateHour">
        <div>
            <div id="diffStartHour">
                <wncm-form-control-hour
                    [readOnly]="!stateHour"
                    [control]="beginHourControl"
                    placeholder="Heure de début"
                ></wncm-form-control-hour>
            </div>

            <div id="diffEndHour">
                <wncm-form-control-hour
                    [readOnly]="!stateHour"
                    [control]="endHourControl"
                    placeholder="Heure de fin"
                ></wncm-form-control-hour>
            </div>
        </div>
    </div>
    <hr *ngIf="userService.hasFeature('HourlySensitivity')" />

    <!-- Météo -->
    <wncm-form-control-slide-toggle
        *ngIf="userService.hasFeature('WeatherSensitivity')"
        [control]="isWeatherFiltered"
        placeholder="En fonction de la météo"
    ></wncm-form-control-slide-toggle>
    <!-- <mat-slide-toggle (change)="changeWeather($event)" labelPosition="after">En fonction de la météo ?</mat-slide-toggle> -->
    <div *ngIf="stateWeather" class="paramLine">
        <mat-button-toggle-group
            [formControl]="weatherControl"
            class="toggleGroup"
            fxLayout="row"
        >
            <mat-button-toggle
                class="toggleButton"
                [value]="4"
                aria-label="Text align left"
                fxFlex
            >
                <i class="material-icons weather">wb_sunny</i>
                <span>Par beau temps</span>
            </mat-button-toggle>
            <mat-button-toggle
                class="toggleButton"
                [value]="5"
                aria-label="Text align left"
                fxFlex
            >
                <i class="material-icons weather">filter_drama</i>
                <span>Par mauvais temps</span>
            </mat-button-toggle>

            <mat-button-toggle
                class="toggleButton"
                [value]="2"
                aria-label="Text align left"
                fxFlex
            >
                <i class="material-icons weather">flash_on</i>
                <span>Par temps pluvieux</span>
            </mat-button-toggle>
            <mat-button-toggle
                class="toggleButton"
                [value]="3"
                aria-label="Text align left"
                fxFlex
            >
                <i class="material-icons weather">ac_unit</i>
                <span>Par temps neigeux</span>
            </mat-button-toggle>
        </mat-button-toggle-group>
    </div>
    <hr *ngIf="userService.hasFeature('WeatherSensitivity')" />

    <!-- Températures -->
    <wncm-form-control-slide-toggle
        *ngIf="userService.hasFeature('WeatherSensitivity')"
        [control]="isTempFiltered"
        placeholder="En fonction des températures"
    ></wncm-form-control-slide-toggle>
    <!-- <mat-slide-toggle (change)="changeTemperature($event)" labelPosition="after">En fonction des températures ?</mat-slide-toggle> -->
    <div class="paramLine" *ngIf="stateTemperature">
        <div>
            <table>
                <tr>
                    <td>
                        <wncm-form-control-number-plus-less
                            [control]="minTempControl"
                            placeholder="De"
                            [max]="maxTempControl.value"
                            [activeValue]="this.minTempControl.value"
                        ></wncm-form-control-number-plus-less>
                    </td>
                    <td class="last-td">
                        <wncm-form-control-number-plus-less
                            [control]="maxTempControl"
                            placeholder="A"
                            [min]="minTempControl.value"
                            [activeValue]="this.maxTempControl.value"
                        ></wncm-form-control-number-plus-less>
                    </td>
                </tr>
            </table>
        </div>
    </div>
    <hr *ngIf="userService.hasFeature('WeatherSensitivity')" />

    <!-- Seul dans la boucle - seulement campagne privée -->
    @if (isLoopOverride != null) {
    <wncm-form-control-slide-toggle
        [control]="isLoopOverride"
        placeholder="Seul dans la boucle"
    >
    </wncm-form-control-slide-toggle>
    <div
        class="paramLine loopOverrideContent"
        *ngIf="isLoopOverride.value === true"
    >
        <i>
            Votre spot diffusera à la place de tous les autres durant ses
            périodes de diffusion
        </i>
    </div>
    }
</div>
